import PropTypes from 'prop-types';
import { Box, TextField } from '@mui/material';

import { CustomAutocomplete } from '../../utils/StyledInputs';

// Selettore dell'entità master GD (entity_master_gd) — sprint 019 GD (TDD FE §4.5).
// Alimentato da GET /entities/gd_registration. Usato sia nel flusso GD-only sia nel
// PD-bundle quando l'utente sceglie "anche GD". Distinto dal Circolo di Appartenenza
// (entity_id), che resta il campo anagrafico esistente.
export default function GdMasterEntitySelect({ value, onChange, options, error, disabled, label = 'Entità GD *' }) {
  return (
    <CustomAutocomplete
      required
      disabled={disabled}
      // Quando il campo è disabilitato nascondi la freccetta del dropdown.
      forcePopupIcon={disabled ? false : 'auto'}
      id="register-gd-entity"
      options={options || []}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      getOptionLabel={(option) => option.name || ''}
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option.id}>
          {option.name}
        </Box>
      )}
      value={value}
      onChange={(e, val) => onChange(val)}
      renderInput={(params) => (
        <TextField {...params} error={!!error} label={label} variant="outlined" />
      )}
    />
  );
}

GdMasterEntitySelect.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool,
  label: PropTypes.string,
};
